import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { MapModel } from '@/types/models';
import { Button } from '@/shared/Button';
import { Icon } from '@/shared/Icon';
import { SubmapNotes } from './SubmapNotes/SubmapNotes.component';

interface SubmapItemProps {
  model: MapModel;
  onOpenClick: () => void;
  onDownloadClick: () => void;
}

export const SubmapItem = ({
  model,
  onOpenClick,
  onDownloadClick,
}: SubmapItemProps): JSX.Element => {
  const [isInfoActive, setIsInfoActive] = useState<boolean>(false);

  const toggleInfo = (): void => setIsInfoActive(prev => !prev);

  return (
    <li className="border-b border-b-divide py-2 last:border-b-0">
      <div className="flex flex-row flex-nowrap items-center justify-between">
        {model.name}
        <div className="flex flex-row flex-nowrap items-center">
          <Button
            data-testid="submap-info-button"
            variantStyles="quiet"
            className="mr-4 p-0"
            title="Diagram notes"
            aria-pressed={isInfoActive}
            onClick={toggleInfo}
          >
            <Icon
              name="info"
              className={twMerge('h-5 w-5', isInfoActive ? 'fill-primary-500' : 'fill-font-400')}
            />
          </Button>

          <Button
            data-testid="download-submap-button"
            variantStyles="quiet"
            className="mr-4 p-0"
            title="Download"
            onClick={onDownloadClick}
          >
            <Icon name="download" className="h-6 w-6 fill-font-500" />
          </Button>

          <Button
            variantStyles="secondary"
            className="h-6"
            data-testid={`${model.name}-open`}
            onClick={onOpenClick}
          >
            Open
          </Button>
        </div>
      </div>

      {isInfoActive && <SubmapNotes model={model} />}
    </li>
  );
};
